import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasRoleDirective } from '../has-role.directive';
import { HasPermissionDirective } from '../has-permission.directive';



@NgModule({
  declarations: [HasRoleDirective, HasPermissionDirective],
  imports: [
    CommonModule,
    
  ],
  exports: [HasRoleDirective, HasPermissionDirective]
})
export class PermissionsModule { }
